import { Component, OnInit } from '@angular/core';
import { TranslateModule, TranslateService } from '@ngx-translate/core';
import { Subscription } from 'rxjs';

@Component({
    selector: 'app-footer',
    imports: [
        TranslateModule,
    ],
    templateUrl: './footer.component.html',
    styleUrl: './footer.component.scss'
})
export class FooterComponent implements OnInit {
  desFooter: any[] = [];
  private langChangeSub!: Subscription;
  constructor(private translate: TranslateService) {}

  ngOnInit() {
    this.updateDesFooter();

    this.langChangeSub = this.translate.onLangChange.subscribe(() => {
      this.updateDesFooter();
    });
  }

  updateDesFooter() {
    this.translate.get('footer').subscribe((translatedTitle) => {
      this.desFooter = [
        {
          label: translatedTitle.headOffice.title,
          sub: [
            {
              icon: 'assets/images/address-white.png',
              text: translatedTitle.headOffice.address,
            },
            {
              icon: 'assets/images/phone.png',
              text: translatedTitle.headOffice.phone1,
            },
            {
              icon: 'assets/images/phone.png',
              text: translatedTitle.headOffice.phone2,
            },
            {
              icon: 'assets/images/mail.png',
              text: translatedTitle.headOffice.mail,
            },
          ],
        },
        {
          label: translatedTitle.branchDanang.title,
          sub: [
            {
              icon: 'assets/images/address-white.png',
              text: translatedTitle.branchDanang.address,
            },
            {
              icon: 'assets/images/phone.png',
              text: translatedTitle.branchDanang.phone1,
            },
            {
              icon: 'assets/images/phone.png',
              text: translatedTitle.branchDanang.phone2,
            },
            {
              icon: 'assets/images/mail.png',
              text: translatedTitle.branchDanang.mail,
            },
          ],
        },
        {
          label: translatedTitle.fieldsOfOperation.title1,
          text: [
            translatedTitle.fieldsOfOperation.title2,
            translatedTitle.fieldsOfOperation.title3,
            translatedTitle.fieldsOfOperation.title4,
            translatedTitle.fieldsOfOperation.title5,
            translatedTitle.fieldsOfOperation.title6,
          ],
        },
      ];
    });
  }
  ngOnDestroy() {
    if (this.langChangeSub) {
      this.langChangeSub.unsubscribe();
    }
  }
}
